export default __webpack_public_path__ + "static/media/PAN.e601282a.svg";